// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-container {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  z-index: 9999 !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
  min-width: 300px !important;
  transition: all 0.3s ease; }
  .progress-bar-container.hidden {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(-10px);
    pointer-events: none; }
  .progress-bar-container.visible {
    opacity: 1;
    transform: translate(-50%, -50%) translateY(0); }

.progress-bar-wrapper {
  position: relative;
  width: 100%; }

.progress-title {
  color: #244EA2;
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 18px;
  font-weight: 600; }

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px; }

.progress-fill {
  width: 0%;
  height: 100%;
  background-color: #244EA2;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; }

.progress-message {
  color: #6c757d;
  margin: 0;
  text-align: center;
  font-size: 14px; }

.progress-percentage {
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5); }

@keyframes shimmer {
  0% {
    left: -100%; }
  100% {
    left: 100%; } }

@keyframes pulse {
  0%, 100% {
    opacity: 1; }
  50% {
    opacity: 0.7; } }

.progress-bar-container.loading .progress-fill::after {
  animation: shimmer 1.5s infinite; }

.progress-bar-container.complete .progress-fill {
  animation: pulse 0.5s ease-in-out; }

.progress-bar-container.complete .progress-message {
  color: #4bb543;
  font-weight: 600; }

@media (max-width: 768px) {
  .progress-bar-container {
    padding: 12px;
    margin: 0 8px; }
  .progress-message {
    font-size: 13px; } }

@media (max-width: 480px) {
  .progress-bar-container {
    padding: 10px; }
  .progress-message {
    font-size: 12px; } }

.progress-bar-container:focus-within {
  outline: 2px solid #244EA2;
  outline-offset: 2px; }

@media (prefers-color-scheme: dark) {
  .progress-bar-container {
    background: rgba(33, 37, 41, 0.95);
    border-color: rgba(255, 255, 255, 0.1); }
  .progress-message {
    color: #adb5bd; } }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom/components/_progress-bar.scss"],"names":[],"mappings":"AAkCA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,wBAAwB;EACxB,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,mDAAgD;EAChD,2BAA2B;EAC3B,yBAzCqC,EAAA;EA8BvC;IAcI,UAAU;IACV,kDAAkD;IAClD,oBAAoB,EAAA;EAhBxB;IAoBI,UAAU;IACV,8CAA8C,EAAA;;AAIlD;EACE,kBAAkB;EAClB,WAAW,EAAA;;AAGb;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2CAAwC,EAAA;;AAI1C;EACE;IACE,WAAW,EAAA;EAEb;IACE,UAAU,EAAA,EAAA;;AAId;EACE;IACE,UAAU,EAAA;EAEZ;IACE,YAAY,EAAA,EAAA;;AAKhB;EAGM,gCAAgC,EAAA;;AAHtC;EASM,iCAAiC,EAAA;;AATvC;EAaM,cAnIc;EAoId,gBAAgB,EAAA;;AAMtB;EACE;IACE,aAAa;IACb,aAAa,EAAA;EAGf;IACE,eAAe,EAAA,EAChB;;AAGH;EACE;IACE,aAAa,EAAA;EAGf;IACE,eAAe,EAAA,EAChB;;AAIH;EAEI,0BAnKgB;EAoKhB,mBAAmB,EAAA;;AAKvB;EACE;IACE,kCAAkC;IAClC,sCAAsC,EAAA;EAGxC;IACE,cAAc,EAAA,EACf","sourcesContent":["// Variáveis SCSS\n$progress-bar-height: 8px;\n$progress-bar-border-radius: 4px;\n$progress-bar-bg: #e9ecef;\n$progress-bar-transition: all 0.3s ease;\n\n// Variantes de cor\n$progress-variants: (\n  'default': #244EA2,\n  'success': #4bb543,\n  'warning': #fece22,\n  'danger': #ec221f,\n  'info': #244EA2\n);\n\n// Tamanhos\n$progress-sizes: (\n  'sm': (\n    height: 6px,\n    font-size: 12px,\n    padding: 8px 0\n  ),\n  'md': (\n    height: 8px,\n    font-size: 14px,\n    padding: 12px 0\n  ),\n  'lg': (\n    height: 12px,\n    font-size: 16px,\n    padding: 16px 0\n  )\n);\n\n.progress-bar-container {\n  position: fixed !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  z-index: 9999 !important;\n  background-color: white !important;\n  padding: 20px !important;\n  border-radius: 10px !important;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.3) !important;\n  min-width: 300px !important;\n  transition: $progress-bar-transition;\n  \n  &.hidden {\n    opacity: 0;\n    transform: translate(-50%, -50%) translateY(-10px);\n    pointer-events: none;\n  }\n  \n  &.visible {\n    opacity: 1;\n    transform: translate(-50%, -50%) translateY(0);\n  }\n}\n\n.progress-bar-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.progress-title {\n  color: #244EA2;\n  margin: 0 0 15px 0;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 20px;\n  background-color: #e9ecef;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.progress-fill {\n  width: 0%;\n  height: 100%;\n  background-color: #244EA2;\n  transition: width 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.progress-message {\n  color: #6c757d;\n  margin: 0;\n  text-align: center;\n  font-size: 14px;\n}\n\n.progress-percentage {\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);\n}\n\n// Animações\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n// Estados\n.progress-bar-container {\n  &.loading {\n    .progress-fill::after {\n      animation: shimmer 1.5s infinite;\n    }\n  }\n  \n  &.complete {\n    .progress-fill {\n      animation: pulse 0.5s ease-in-out;\n    }\n    \n    .progress-message {\n      color: map-get($progress-variants, 'success');\n      font-weight: 600;\n    }\n  }\n}\n\n// Responsividade\n@media (max-width: 768px) {\n  .progress-bar-container {\n    padding: 12px;\n    margin: 0 8px;\n  }\n  \n  .progress-message {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .progress-bar-container {\n    padding: 10px;\n  }\n  \n  .progress-message {\n    font-size: 12px;\n  }\n}\n\n// Acessibilidade\n.progress-bar-container {\n  &:focus-within {\n    outline: 2px solid map-get($progress-variants, 'default');\n    outline-offset: 2px;\n  }\n}\n\n// Modo escuro (se aplicável)\n@media (prefers-color-scheme: dark) {\n  .progress-bar-container {\n    background: rgba(33, 37, 41, 0.95);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .progress-message {\n    color: #adb5bd;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
